/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 *
 * Easter egg achievement system backed by localStorage.
 */

const STORAGE_KEY = 'cb-achievements';

export interface Achievements {
  konamiCode?: { found: boolean; date: string };
  retroThemeUnlocked?: boolean;
}

function read(): Achievements {
  if (typeof window === 'undefined') return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function write(data: Achievements) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function unlockKonamiCode() {
  const a = read();
  a.konamiCode = { found: true, date: new Date().toISOString() };
  a.retroThemeUnlocked = true;
  write(a);
  window.dispatchEvent(new CustomEvent('achievement-unlocked'));
}

export function hasKonamiCode(): boolean {
  return read().konamiCode?.found === true;
}

export function isRetroUnlocked(): boolean {
  return read().retroThemeUnlocked === true;
}

export function getAchievements(): Achievements {
  return read();
}
